import React, { lazy, Suspense } from 'react'
import Loader from 'components/Reusable/Loader'

const Contact = lazy(() => import('components/Sections/Contact'))
const Footer = lazy(() => import('components/Layout/Footer'))

function ContactPage() {
    const loader = () => <Loader />

    const MainComponent = () => (
        <Suspense fallback={loader()}>
            <Contact />
            <Footer />
        </Suspense>
    )

    return MainComponent()
}

export default ContactPage